import { AnswerItem } from '../component/AnswerItem'
import shuffle from 'lodash/shuffle'
export const randomAnswers = (answerItems: AnswerItem[]) => {
  const answers = shuffle(answerItems.filter(a => !a.fixOrder))

  answerItems.forEach((a, i)=> {
    if (a.fixOrder) {
      answers.splice(i, 0, a)
    }
  })

  return answers
}

export const addOrderToTheAnswer = (answerItems: AnswerItem[]) => {
  return answerItems.map((v, i) => Object.assign({}, v, { value: `${v.value}_${i}` }))
}